import { DrawerForm, DrawerSizeEnum } from '@acceso/design-system';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { InputText } from '@/components/FormFields/InputText';
import { DrawerFormDataType, FormTypeEnum } from '@/types';

import { useSupportsDrawerFormState } from '../../hooks/useSupportsDrawerFormState';
import { TSupport, TSupportForm } from '../../types';

export type TSupportsDrawerFormProps = {
  isOpen: boolean;
  data?: DrawerFormDataType<TSupport>;
  onClose: () => void;
  onSubmit: (data: TSupportForm) => void;
  isMutating: boolean;
};

export const SupportsDrawerForm = ({
  isOpen,
  onClose,
  onSubmit,
  isMutating,
  data,
}: TSupportsDrawerFormProps) => {
  const { t } = useTranslation();
  const { form, initialValues } = useSupportsDrawerFormState();

  const isUpdate = data?.type === FormTypeEnum.UPDATE;

  const handleSubmit = form.handleSubmit(onSubmit);

  useEffect(() => {
    if (isOpen) {
      if (data?.type === FormTypeEnum.UPDATE) {
        form.reset({ name: data.data.alias[0] || '' });
      }
    } else {
      form.reset(initialValues);
    }
  }, [isOpen]);

  return (
    <DrawerForm
      title={isUpdate ? t('Editar soporte') : t('Crear nuevo soporte')}
      isOpen={isOpen}
      onCancel={() => {
        onClose();
        form.reset(initialValues);
      }}
      isMutating={isMutating}
      onSubmit={handleSubmit}
      size={DrawerSizeEnum.MD}
      labels={{
        submit: t('Guardar'),
        cancel: t('Cancelar'),
      }}
    >
      <InputText
        form={form}
        name="name"
        required
        label={t('Nombre')}
        placeholder={t('Escribe aquí el nombre')}
      />
    </DrawerForm>
  );
};
